import React, { useCallback } from 'react';
import { Alert } from 'reactstrap';

import OrderAlertTypes, {
  getAlertColor,
  isOrderAlertType,
} from '../../types/order/OrderAlert';

const useAlerts = ({ generalAlerts = [], errorAlerts = [] }) => {
  const renderErrorAlerts = useCallback(() => {
    return errorAlerts.map((alert, index) => (
      <Alert key={index} className={`${OrderAlertTypes.DANGER}`} color="danger">
        <div dangerouslySetInnerHTML={{ __html: alert.message }} />
      </Alert>
    ));
  }, [errorAlerts]);

  const renderGeneralAlerts = useCallback(() => {
    return generalAlerts.map((alert, index) => {
      if (!isOrderAlertType(alert.type)) {
        return null;
      }

      const color = getAlertColor(alert.type);

      return (
        <Alert key={index} color={color} className={color}>
          <div dangerouslySetInnerHTML={{ __html: alert.message }} />
        </Alert>
      );
    });
  }, [generalAlerts]);

  return { renderErrorAlerts, renderGeneralAlerts };
};

export default useAlerts;
